import { Modal as ModalBase, Box, Typography, Stack } from '@mui/material';
import Button from '../CustomButton';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '550px',
  width: '90%',
  maxHeight: '85vh',
  display: 'flex',
  flexDirection: 'column',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 5,
  padding: 4,
  textAlign: 'center',

  h5: {
    fontSize: '20px',
    fontWeight: 700,
    color: theme => theme.palette.primary.main,
  },
  p: {
    fontSize: '15px',
    fontWeight: 400,
    marginBottom: '1rem',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
  },
};

export default function Modal({ title, description, isOpen, handleClose, icon, confirm, redirect, isRedirect }) {
  return (
    <ModalBase
      open={isOpen}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        handleClose();
      }}
      disableEscapeKeyDown
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {icon && <Box sx={{ display: 'flex', justifyContent: 'center' }}>{icon}</Box>}
        <Stack spacing={2} my={3} sx={{ overflowY: 'auto', flex: 1 }}>
          <Typography variant="h5">{title}</Typography>
          <Typography variant="p">{description}</Typography>
        </Stack>

        {!confirm || confirm === null ? (
          <Button
            variant="contained"
            onClick={() => {
              handleClose();
              if (isRedirect) redirect();
            }}
          >
            Ok
          </Button>
        ) : confirm.singleButton ? (
          <Button
            variant="outlined"
            onClick={() => {
              confirm.accept();
              handleClose();
            }}
          >
            {confirm.label ?? 'Confirmar'}
          </Button>
        ) : (
          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                handleClose();
              }}
            >
              Não
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                confirm.accept();
                handleClose();
              }}
            >
              {confirm.label ?? 'Sim'}
            </Button>
          </Stack>
        )}
      </Box>
    </ModalBase>
  );
}
